import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles({
    root: {
        "& .MuiInputBase-root": {
            padding: 0,
            "& .MuiButtonBase-root": {
                padding: 0,
                paddingLeft: 0
            },
            "& .MuiInputBase-input": {
                padding: 15,
                paddingLeft: 5,
                paddingRight: 0,
                marginRight: -15
            },
            "& .MuiInputAdornment-root": {
                marginLeft: -15
            }
        }
    },
    dateField: {
        marginTop: 0,
    },
    iconDatePicker: {
        padding: 0,
        marginRight: -5,
    },
});
